import {
  faChartPie,
  faCoin,
  faReceipt,
  faShoppingBasket,
  faUmbrella,
  faUser,
  faUsers,
} from "@fortawesome/pro-light-svg-icons";
import { useSelector } from "react-redux";
import { Outlet } from "react-router";
import Header from "../../components/Header";
import HelpPanel from "../../components/HelpPanel";
import { ROLES } from "../../utils/constants";
import * as S from "./styles";

function Admin() {
  const { user } = useSelector((state) => state.authReducer);
  window.document.title = "Organnact - Admin";
  const gestor = user?.roles?.includes(ROLES.gestor);

  const ADMIN_MENU_ITEMS = [
    {
      icon: faShoppingBasket,
      label: "Vitrine",
      link: "/admin/vitrine",
    },
    {
      label: "Dashboard",
      link: "/admin/dashboard",
      permission: [ROLES.admin],
      icon: faChartPie,
    },
    {
      label: "Produtos",
      link: "/admin/produtos",
      permission: [ROLES.admin],
      icon: faUmbrella,
    },
    {
      label: "Pedidos",
      link: "/admin/pedidos",
      icon: faReceipt,
      permission: [ROLES.admin, ROLES.gestor],
    },
    {
      label: "Usuários",
      link: "/admin/usuarios",
      permission: [ROLES.admin],
      icon: faUsers,
    },
    {
      label: "Perfil",
      link: "/admin/perfil",
      permission: [ROLES.admin],
      icon: faUser,
    },
  ];
  const GESTOR_MENU_ITEMS = [
    {
      icon: faShoppingBasket,
      label: "Vitrine",
      link: "/admin/vitrine",
    },
    {
      label: "Pedidos",
      link: "/admin/pedidos",
      icon: faReceipt,
      permission: [ROLES.admin, ROLES.gestor],
    },
    {
      label: "OrgaDots",
      link: "/admin/orgadots",
      icon: faCoin,
    },
    {
      label: "Usuários",
      link: "/admin/usuarios",
      permission: [ROLES.admin],
      icon: faUsers,
    },
    {
      label: "Perfil",
      link: "/admin/perfil",
      permission: [ROLES.admin],
      icon: faUser,
    },
  ];

  return (
    <S.Container>
      <Header
        hideSearch={true}
        menuItems={gestor ? GESTOR_MENU_ITEMS : ADMIN_MENU_ITEMS}
      />
      <S.AdminContent>
        <Outlet />
      </S.AdminContent>
      <HelpPanel />
    </S.Container>
  );
}

export default Admin;
